import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col, Divider } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { IdGen } from 'utils'

import * as CuentaContableService from 'services/cuentaContable.service'

import * as FormGroups from './formGroups'
import * as Tables from './tables'

export const ValidationSchema = Yup.object().shape({
  busqueda: Yup.string().min(2).notRequired()
})

const AsignacionEnlacesSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const [_keyTabla, setKeyTabla] = React.useState(IdGen.newId())

  const [listaCuentasContables, setListaCuentasContables] = React.useState([])

  const formInitialValues = React.useMemo(() => {
    return {
      busqueda: '',
      flagSoloPendientes: true
    }
  }, [])

  const onSubmit = React.useCallback(
    (formData, { setSubmitting }) => {
      __zariContext.loader.open('Consultando cuentas contables')
      CuentaContableService.getCuentasContablesAsAsignacionEnlaceCierreClase679(formData)
        .then(({ data }) => {
          if (data) {
            if (data.length === 0) {
              __zariContext.snack('info', 'No se ha encontrado registros con los filtros indicados.')
              setListaCuentasContables([])
              return
            }

            const nuevaSalida = [...data]
            nuevaSalida.push({ filaVacia: true })
            nuevaSalida.push({ filaVacia: true })
            nuevaSalida.push({ filaVacia: true })
            nuevaSalida.push({ filaVacia: true })
            nuevaSalida.push({ filaVacia: true })

            setListaCuentasContables(nuevaSalida)
            setKeyTabla(IdGen.newId())
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <>
      <Divider title='Esquema de enlaces' />
      <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, handleSubmit }) => (
          <Form>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={4}>
                    <FormGroups.BusquedaFormGroup
                      iError={errors.busqueda}
                      iTouched={touched.busqueda}
                      fIsSubmitting={isSubmitting}
                    />
                  </Col>
                  <Col md={2}>
                    <FormGroups.FlagSoloPendientesFormGroup
                      iValue={values.flagSoloPendientes}
                      iError={errors.flagSoloPendientes}
                      iTouched={touched.flagSoloPendientes}
                      fIsSubmitting={isSubmitting}
                    />
                  </Col>
                  <Col md={4}>
                    <Button disabled={isSubmitting} onClick={handleSubmit}>
                      Consultar
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      {listaCuentasContables.length > 0 && (
        <>
          <Tables.CuentasContablesTable key={_keyTabla} listaCuentasContables={listaCuentasContables} />
        </>
      )}
    </>
  )
}

export default React.memo(AsignacionEnlacesSection)
